import ajax from './ajax';
import Console from './console';
import TokenStorage from './token_storage';

const settings = window.Settings;
const console = new Console(settings.SESSIONWIDGET_DEBUG);
const tokenKeyPrefix = window.Settings.SESSIONWIDGET_KEY_PREFIX;
const apiUrl = settings.SESSIONWIDGET_REVOKE_TOKEN_API;
const keyCookiePath = settings.SESSIONWIDGET_STORAGE_KEY_COOKIE_PATH;
const keyCookieName = settings.SESSIONWIDGET_STORAGE_KEY_COOKIE_NAME;
const storage = new TokenStorage(settings);
const removeDate = new Date(0).toUTCString();

const tokens = Object.keys(storage.storage)
    .filter(key => key.indexOf(tokenKeyPrefix) > -1)
    .map(key => {
        const token = storage.getByKey(key, true);

        storage.storage.removeItem(key);
        if (token && token.clientId && token.access_token) {
            const query = `token=${token.access_token}&client_id=${token.clientId}`;

            ajax(apiUrl, 'POST', query);
        }
        return token;
    });

document.cookie = `${keyCookieName}=; path=${keyCookiePath}; expires=${removeDate};`;

console.log('revoke: ', tokens);



// WEBPACK FOOTER //
// ./static_source/js/ssw_clear.js